import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PageNotesProvider } from './contexts/PageNotesContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { router } from './routing/router';

// AuthProvider sits above RouterProvider rather than inside it: the data-
// router API (RouterProvider) doesn't accept children between itself and
// the route tree, but React context still propagates through, so any
// route component can `useAuth()` as before. AuthProvider does not call
// any router hooks, so it's safe outside the router subtree.
//
// PageNotesProvider (#486) sits INSIDE AuthProvider so its one-shot
// /me/can-edit-page-notes fetch fires only after a session exists. It
// has no router dependency either.
export function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <PageNotesProvider>
          <RouterProvider router={router} />
        </PageNotesProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
